<template>
  <pui-error>
    <template #title>
      <i18n path="platform.settings_error.title"></i18n>
    </template>
    <template #subtitle>
      <!-- No subtitle -->
      <span></span>
    </template>
    <template #action>
      <i18n path="platform.settings_error.action"></i18n>
    </template>
  </pui-error>
</template>

<script>
import puiError from './Error';

export default {
  components: {
    puiError,
  },
};
</script>
